<template>
    <path class="up"
          d="M5.76822 0.921865L8.63318 4.35982C9.17595 5.01114 8.7128 6 7.86496 6L2.13504 6C1.2872 6 0.824046 5.01115 1.36682 4.35982L4.23178 0.921866C4.63157 0.442111 5.36842 0.44211 5.76822 0.921865Z"
          fill="#D1D0D0"/>
    <path class="down"
          d="M4.23178 16.0781L1.36682 12.6402C0.824048 11.9889 1.2872 11 2.13504 11H7.86496C8.7128 11 9.17595 11.9889 8.63318 12.6402L5.76822 16.0781C5.36843 16.5579 4.63157 16.5579 4.23178 16.0781Z"
          fill="#D1D0D0"/>
</template>

<script>
    export default {
        name: 'icon-up-down'
    }
</script>